import { render, staticRenderFns } from "./DomainPaneHeader.vue?vue&type=template&id=3dca6a96&scoped=true"
import script from "./DomainPaneHeader.vue?vue&type=script&lang=js"
export * from "./DomainPaneHeader.vue?vue&type=script&lang=js"
import style0 from "./DomainPaneHeader.vue?vue&type=style&index=0&id=3dca6a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca6a96",
  null
  
)

export default component.exports